import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  notificationData: {},
  notificationStatus: "idle"
};

export const getNotificationData = createAsyncThunk(
  "v1/admin/notification/list",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(
        `v1/admin/notification/list?per_page=15&page=${params?.page}`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotificationData.pending, (state, action) => {
      state.notificationStatus = "pending";
    });
    builder.addCase(getNotificationData.fulfilled, (state, action) => {
      if (
        state.notificationData?.[action.meta?.arg?.notification_id] &&
        !action.meta?.arg?.clearState
      ) {
        if (action.payload?.data?.data?.result) {
          state.notificationData[action.meta?.arg?.notification_id] = {
            ...action.payload?.data?.data,
            result: [
              ...state.notificationData[action.meta?.arg?.notification_id].result,
              ...action.payload?.data?.data?.result,
            ],
          };
        } else {
          state.notificationData[action.meta?.arg?.notification_id] = {
            ...action.payload?.data?.data,
            result: [
              ...state.notificationData[action.meta?.arg?.notification_id].result,
            ],
          };
        }
      } else {
        state.notificationData[action.meta?.arg?.notification_id] = {
          ...action.payload?.data?.data,
          page: 1,
        };
      }
      state.notificationStatus = "fulfilled";
    });
    builder.addCase(getNotificationData.rejected, (state, action) => {
      state.notificationStatus = "failed";
    });
  },
});

export const { updateConfig } = notificationSlice.actions;

export default notificationSlice.reducer;
